import { BlockNoteSchema } from "@blocknote/core";
import { TimerBlock } from "src/components/blocks/Timer";
import { MetricBlock } from "../components/blocks/Metric";

export const blocknoteSchema = BlockNoteSchema.create().extend({
  blockSpecs: {
    timer: TimerBlock(),
    metric: MetricBlock(),
  },
});

export type Block = typeof blocknoteSchema.Block;
